module.exports = __webpack_public_path__ + "static/media/expire-2.ca32cf88.mp3";